import React, { useEffect, useState } from "react";
import Alerts from "../util/Alerts";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import ReactTable from "react-table";
import axios from "axios";
import { routes } from "../gen/General";
import { Link } from "react-router-dom";
import { ModalImportExcel } from "../util/ModalImportExcel";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ModalCargando } from "../coms/ModalCargando";
import { ListRedes } from "./utils";
import { ModalInformeImportacion } from "./ModalInformeImportacion";

export const Beneficios = () => {
    const alert = React.useRef();
    const [data, setData] = useState({
        list: [],
        pages: 0,
        loading: false,
        number: 0,
        size: 10,
        pageSize: 10,
        filtered: [],
    });

    const [query, setQuery] = useState({
        page: 0,
        pages: 0,
        loading: false,
        number: 0,
        size: 10,
        pageSize: 10,
        filtered: [],
        red: "",
        esp: "",
        plan: "",
        aseg: "",
        cdRedCob: "",
    });
    const [open, setOpen] = useState(false);
    const [planes, setPlanes] = useState(false);
    const [asegs, setAsegs] = useState(false);
    const [openEspere, setOpenEspere] = useState(false);
    const [esps, setEsps] = useState([]);
    const [openHistorial, setOpenHistorial] = useState(false);
    const [redesCoberturas, setRedesCoberturas] = useState([]); // tipos de redes
    const history = useHistory();

    useEffect(() => {
        getAseguradora();
        getEspecialidades();
        fetchRedesCoberturas();
    }, []);

    function getAseguradora() {
        axios
            .get(routes.base + "/aseguradora")
            .then(resp => {
                setAsegs(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getPlanes() {
        axios
            .get(routes.base + "/planes")
            .then(resp => {
                setPlanes(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getEspecialidades() {
        axios
            .get(routes.base + "/beneficios/especialidades")
            .then(resp => {
                setEsps(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    const handleExport = () => {
        if (window.confirm("Esto tomará tiempo, Está seguro?")) {
            setOpenEspere(true);
            axios
                .get(routes.base + "/beneficios/exportar", { responseType: "arraybuffer" })
                .then(resp => {
                    let blob = new Blob([resp.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    let linkExcel = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = linkExcel;
                    link.setAttribute("download", "Beneficios.xlsx");
                    link.click();
                })
                .catch(err => alert.current.handle_error(err))
                .finally(then => setOpenEspere(false));
        }
    };

    function closeModal() {
        setOpen(false);
        //actualiza los datos
        setQuery({ ...query, loading: true, page: 0 });
        getBeneficios({ ...query, page: 0, pageSize: 10, filtered: [] });
    }

    function closeImportar() {
        setOpen(false);
        //actualiza los datos
        setQuery({ ...query, loading: true, page: 0 });
        getBeneficios({ ...query, page: 0, pageSize: 10, filtered: [] });
        getEspecialidades();
        setOpenHistorial(true);
    }

    const findPlan = id => {
        let plan = (planes || []).find(m => m.cdPlan === id);
        return plan?.dscPlan || "";
    };

    const findAseg = id => {
        let aseg = (asegs || []).find(m => m.cdAseguradora === id);
        return aseg?.nmAseguradora || "";
    };

    const findRedCobertura = id => {
        let red = (redesCoberturas || []).find(m => m.id === id);
        return red?.red || "";
    };

    function getBeneficios(q) {
        axios
            .post(routes.base + "/beneficios", q)
            .then(res => {
                setData({
                    ...data,
                    list: res.data.data,
                    pages: res.data.totalPages,
                    pageSize: 10,
                    loading: false,
                });
            })
            .catch(err => err);
    }

    function closeHistorial() {
        setOpenHistorial(false);
        //actualiza los datos
        setQuery({ ...query, loading: true, page: 0 });
        getBeneficios({ ...query, page: 0, pageSize: 10, filtered: [] });
        getEspecialidades();
    }

    const fetchRedesCoberturas = () => {
        axios
            .get(routes.base + "/red-coberturas")
            .then(resp => setRedesCoberturas(resp.data))
            .catch(err => err);
    };

    return (
        <div className="content ">
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Beneficios</CardTitle>

                    <Row>
                        <Col xs={12}>
                            <Row>
                                <div className="col-lg-4">
                                    <label>{"Aseguradora"}</label>
                                    <select
                                        value={query.aseg}
                                        className="form-control primary"
                                        onChange={e => {
                                            setQuery({ ...query, aseg: e.target.value, page: 0, pageSize: 10 });
                                            getBeneficios({ ...query, aseg: e.target.value, page: 0, pageSize: 10 });
                                        }}
                                    >
                                        <option value="">--Todos--</option>
                                        {(asegs || []).map(a => (
                                            <option key={a.cdAseguradora} value={a.cdAseguradora}>
                                                {a.nmAseguradora}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4">
                                    <label>{"Nombre de Red"}</label>
                                    <select
                                        value={query.cdRedCob}
                                        className="form-control primary"
                                        onChange={e => {
                                            const item = { ...query, cdRedCob: e.target.value, page: 0, pageSize: 10 };
                                            setQuery(item);
                                            getBeneficios(item);
                                        }}
                                    >
                                        <option value="">--Todos--</option>
                                        {(redesCoberturas || []).map(a => (
                                            <option key={a.id} value={a.id}>
                                                {a.red}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4">
                                    <label>{"Red"}</label>
                                    <select
                                        value={query.red}
                                        className="form-control primary"
                                        onChange={e => {
                                            setQuery({ ...query, red: e.target.value, page: 0, pageSize: 10 });
                                            getBeneficios({ ...query, red: e.target.value, page: 0, pageSize: 10 });
                                        }}
                                    >
                                        <option value="">--Todos--</option>
                                        {(ListRedes || []).map(a => (
                                            <option key={a.id} value={a.id}>
                                                {a.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4">
                                    <label>{"Especialidad"}</label>
                                    <select
                                        value={query.esp}
                                        className="form-control primary"
                                        onChange={e => {
                                            setQuery({ ...query, esp: e.target.value, page: 0, pageSize: 10 });
                                            getBeneficios({ ...query, esp: e.target.value, page: 0, pageSize: 10 });
                                        }}
                                    >
                                        <option value="">--Todos--</option>
                                        {(esps || []).map(a => (
                                            <option key={a} value={a}>
                                                {a}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    <br />
                    <br />
                    <Row>
                        <Col xs={12}>
                            <Link to={"/gen/beneficio/new"} className="btn btn-primary">
                                Nuevo Beneficio
                            </Link>

                            <button
                                className="btn btn-success ml-3"
                                title={"Importar desde un archivo excel"}
                                color={"info"}
                                onClick={() => setOpen(true)}
                            >
                                Importar Beneficios
                            </button>

                            <button
                                className="btn btn-danger ml-3"
                                title={""}
                                color={"info"}
                                onClick={() => setOpenHistorial(true)}
                            >
                                Historial de importación
                            </button>

                            <button
                                className="btn btn-warning ml-3"
                                title={"Exportar beneficios a un archivo excel"}
                                color={"info"}
                                onClick={handleExport}
                            >
                                Exportar Beneficios
                            </button>

                            <ModalImportExcel
                                baseUrl={"/beneficios"}
                                titulo={"Beneficios"}
                                alert={alert}
                                open={open}
                                setOpen={closeModal}
                                item={{ file: null }}
                                asincrono={true}
                                closeImportar={closeImportar}
                                msg={
                                    "*Para ver los resultados de la importación dirígete al botón Historial de Importación"
                                }
                            />

                            <ModalCargando
                                open={openEspere}
                                title={"Exportando Beneficios"}
                                subtitule={"Por favor espere, exportando..."}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs={12}>
                            <ReactTable
                                noDataText={"No se ha encontrado información"}
                                previousText={"Anterior"}
                                nextText={"Siguiente"}
                                pageText={"Página"}
                                rowsText={"filas"}
                                ofText={"de"}
                                columns={[
                                    {
                                        Header: "#",
                                        accessor: "cdBeneficio",
                                        id: "id",
                                        Cell: row => {
                                            return <div>{data.number * data.size + (row.index + 1)}</div>;
                                        },
                                        width: 100,
                                        filterable: false,
                                        sortable: false,
                                        minResizeWidth: 10,
                                    },
                                    {
                                        Header: "Aseguradora",
                                        minResizeWidth: 50,
                                        width: 140,
                                        accessor: "cdAseguradora",
                                        filterable: false,
                                        Cell: row => {
                                            return <span>{findAseg(row.original.cdAseguradora)}</span>;
                                        },
                                    },
                                    {
                                        Header: "Nombre de Red",
                                        minResizeWidth: 50,
                                        width: 140,
                                        accessor: "cdRedCob",
                                        filterable: false,
                                        Cell: row => {
                                            return <span>{findRedCobertura(row.original.cdRedCob)}</span>;
                                        },
                                    },
                                    {
                                        Header: "Red",
                                        minResizeWidth: 50,
                                        width: 140,
                                        accessor: "red",
                                    },
                                    {
                                        Header: "Especialidad",
                                        minResizeWidth: 50,
                                        width: 90,
                                        accessor: "especialidad",
                                    },
                                    {
                                        Header: "Proveedor",
                                        minResizeWidth: 50,
                                        width: 140,
                                        accessor: "nombreProveedor",
                                    },
                                    {
                                        Header: "Ciudad",
                                        minResizeWidth: 10,
                                        accessor: "ciudad",
                                        width: 70,
                                    },
                                    {
                                        Header: "Teléfono",
                                        minResizeWidth: 50,
                                        width: 110,
                                        accessor: "telefono",
                                    },
                                ]}
                                getTdProps={(state, rowInfo, column) => {
                                    if (rowInfo && rowInfo.row) {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                history.push("/gen/beneficio/" + rowInfo.original.cdBeneficio);
                                                if (handleOriginal) {
                                                    handleOriginal();
                                                }
                                            },
                                            style: {
                                                cursor: "pointer",
                                                //backgroundColor: rowInfo.index === state.selected ? '#47b2a2' : 'white',
                                                //color: rowInfo.index === state.selected ? 'white' : 'black',
                                                height: 35,
                                            },
                                        };
                                    } else {
                                        return {};
                                    }
                                }}
                                manual
                                data={data.list}
                                pages={data.pages}
                                loading={data.loading}
                                onFetchData={state => {
                                    setQuery({
                                        ...query,
                                        page: state.page,
                                        pageSize: state.pageSize,
                                        loading: true,
                                        filtered: state.filtered,
                                    });
                                    getBeneficios({
                                        ...query,
                                        page: state.page,
                                        pageSize: state.pageSize,
                                        loading: true,
                                        filtered: state.filtered,
                                    });
                                }}
                                sortable={false}
                                defaultPageSize={10}
                                className="-striped -highlight"
                            ></ReactTable>
                        </Col>
                    </Row>
                </CardBody>
                <ModalInformeImportacion alert={alert} open={openHistorial} close={closeHistorial} />
            </Card>
        </div>
    );
};
